import a from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import s from "./iconfont.es5471.js";
const i = {
  display: "block"
}, x = ({ size: e = 16, useVw: c, useRem: l, color: n, withColor: o, removeClassName: t, disableSSR: m, style: r, ...p }) => {
  const h = r ? { ...i, ...r } : i;
  return /* @__PURE__ */ a.createElement(s, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-APIs", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: c ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), height: c ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-APIs"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? d(n, 0, "#262933") : "#262933",
        datafollowfill: o ? d(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M8.087 12.856C8.796 9.154 11.774 6.4 15.316 6.4c2.93 0 5.606 1.983 6.743 4.816a2.16 2.16 0 0 0 1.483 1.282c.388.097.764.24 1.123.425C26.642 13.94 28.1 16.229 28.1 19c0 1.439-.528 3.128-1.492 4.442-.957 1.303-2.276 2.158-3.862 2.158H18.08a.9.9 0 1 0 0 1.8h4.666c2.308 0 4.116-1.263 5.313-2.893 1.189-1.62 1.841-3.68 1.841-5.507 0-3.391-1.788-6.328-4.412-7.678a7.055 7.055 0 0 0-1.508-.57.361.361 0 0 1-.25-.206C22.352 7.116 19.07 4.6 15.315 4.6c-4.54 0-8.152 3.506-8.997 7.917a.362.362 0 0 1-.196.242C3.767 13.99 2.1 16.68 2.1 19.75c0 4.168 3.064 7.65 7.058 7.65h2.88a.9.9 0 0 0 0-1.8h-2.88C6.31 25.6 3.9 23.082 3.9 19.75c0-2.435 1.327-4.491 3.057-5.396a2.16 2.16 0 0 0 1.13-1.498Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M9.728 21.615a.738.738 0 1 1-1.401-.465l1.753-5.126a1.321 1.321 0 0 1 2.5 0l1.751 5.126a.738.738 0 1 1-1.402.465l-.348-1.083h-2.504l-.349 1.083Zm1.63-4.885.851 2.647h-1.76l.854-2.647h.054Zm4.142 4.664a.733.733 0 1 0 1.466 0V19.86h1.232c.533 0 .987-.1 1.361-.297.377-.199.665-.475.863-.83.2-.356.298-.766.298-1.23 0-.465-.098-.875-.294-1.23a2.05 2.05 0 0 0-.846-.837c-.37-.203-.819-.304-1.345-.304h-1.868a.867.867 0 0 0-.867.866v5.397Zm1.466-2.72h.995c.282 0 .515-.05.698-.148a.97.97 0 0 0 .413-.413c.092-.177.139-.381.139-.611 0-.233-.047-.435-.14-.608a.93.93 0 0 0-.412-.407c-.185-.098-.42-.147-.704-.147h-.989v2.333Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M23.532 15.864a.733.733 0 0 0-1.465 0v5.53a.733.733 0 0 0 1.465 0v-5.53Z"
        }
      )
    )
  )));
}, I = x;
export {
  I as default
};
